import { DocumentReference } from "./document-reference";

export class SearchDocumentsRequest {
  docType: string[];
  docReference: DocumentReference[]
  constructor() {
    this.docType = [];
    this.docReference = [];
  }
}
